const EMPTY_VARIABLE_BINDING_STAMP = Object.freeze([]);

function buildVariableBindingIndex(variables) {
  const index = new Map();
  if (!variables || typeof variables !== "object") {
    return index;
  }
  Object.keys(variables).forEach(variableId => {
    const variable = variables[variableId];
    const linked = variable?.linked;
    if (!linked || typeof linked !== "object") {
      return;
    }
    Object.keys(linked).forEach(lookup => {
      if (!linked[lookup]) {
        return;
      }
      const separator = lookup.indexOf(":");
      if (separator < 1 || separator === lookup.length - 1) {
        return;
      }
      const elementId = lookup.slice(0, separator);
      const optionKey = lookup.slice(separator + 1);
      const stamp = index.get(elementId) ?? [];
      stamp.push(optionKey, variableId, variable.default);
      index.set(elementId, stamp);
    });
  });
  return index;
}

function bindingStampFor(index, elementId) {
  return index.get(elementId) ?? EMPTY_VARIABLE_BINDING_STAMP;
}

module.exports = { buildVariableBindingIndex, bindingStampFor, EMPTY_VARIABLE_BINDING_STAMP };
